export enum SettingsRoutes {
  BasePrefix = "settings",
  GreetingSettings = "greetingSettings",
  GetListSettings = "getListSettings",
  ExportSettings = "exportSettings",
  GetSettingsDiff = "getDiff",
  ApplySettings = "apply"
}
